import { FormInput } from "@general-backoffice/core";
import type { TaxProfile } from "@investhinks/api-client";
import React from "react";
import { Alert, Card, CardBody } from "reactstrap";

type RiskStepTaxProfile = Pick<TaxProfile, "riskAcknowledged"> & Record<string, unknown>;

interface RiskStepProps {
  taxProfile: RiskStepTaxProfile | null;
  handleInputChange: (name: string, value: unknown) => void;
  isLoading: boolean;
  t: (key: string, fallback?: string) => string;
}

const RiskStep = ({ taxProfile, handleInputChange, isLoading, t }: RiskStepProps) => (
  <div>
    <h5 className="mb-3">{t("steps.risk.title", "Risk Acknowledgment")}</h5>

    <Alert color="warning">
      <h5 className="alert-heading">
        <i className="fas fa-exclamation-triangle mr-2" />
        {t("steps.risk.warningTitle", "Important Notice")}
      </h5>
      <p>
        {t(
          "steps.risk.warningText1",
          "If the Spanish Tax Authority (Hacienda) determines that your income from referral commissions constitutes regular economic activity, you may be required to:"
        )}
      </p>
      <ul>
        <li>{t("steps.risk.point1", "Register as autónomo retroactively")}</li>
        <li>{t("steps.risk.point2", "Pay back social security contributions")}</li>
        <li>{t("steps.risk.point3", "File and pay VAT for previous periods")}</li>
      </ul>
      <p className="mb-0">
        {t(
          "steps.risk.warningText2",
          "We recommend consulting with a tax advisor if you expect to receive regular payments."
        )}
      </p>
    </Alert>

    <Card className="bg-light mt-3">
      <CardBody>
        <FormInput.Switch
          label={t("steps.risk.checkbox", "I understand and acknowledge the risks described above")}
          name="riskAcknowledged"
          checked={taxProfile?.riskAcknowledged || false}
          onChange={(e) => handleInputChange("riskAcknowledged", e.target.checked)}
          disabled={isLoading}
        />
      </CardBody>
    </Card>
  </div>
);

export default RiskStep;
